var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 12.0007C15.8333 12.5007 15.6933 12.974 15.4467 13.374C15.3067 13.614 15.1267 13.8273 14.92 14.0007C14.4533 14.4207 13.84 14.6673 13.1667 14.6673C12.3533 14.6673 11.6267 14.3007 11.1467 13.7273C11.1333 13.7073 11.1133 13.694 11.1 13.674C11.02 13.5807 10.9467 13.4806 10.8867 13.374C10.64 12.974 10.5 12.5007 10.5 12.0007C10.5 11.1607 10.8867 10.4073 11.5 9.92065C11.96 9.55399 12.54 9.33398 13.1667 9.33398C13.8333 9.33398 14.4333 9.57396 14.9 9.98063C14.98 10.0406 15.0533 10.114 15.12 10.1873C15.56 10.6673 15.8333 11.3007 15.8333 12.0007Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1585 11.9863H12.1719",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1641 11.0137V13.007",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61719 4.96094L8.50386 8.36759L14.3505 4.98092",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.408V8.36133",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9071 6.11399V9.88734C14.9071 9.92068 14.9071 9.94731 14.9004 9.98064C14.4338 9.57398 13.8337 9.334 13.1671 9.334C12.5404 9.334 11.9604 9.554 11.5004 9.92067C10.8871 10.4073 10.5004 11.1607 10.5004 12.0007C10.5004 12.5007 10.6404 12.974 10.8871 13.374C10.9471 13.4807 11.0204 13.5807 11.1004 13.674L9.88042 14.3473C9.12042 14.774 7.88041 14.774 7.12041 14.3473L3.56041 12.374C2.75375 11.9273 2.09375 10.8073 2.09375 9.88734V6.11399C2.09375 5.19399 2.75375 4.074 3.56041 3.62733L7.12041 1.65398C7.88041 1.22732 9.12042 1.22732 9.88042 1.65398L13.4404 3.62733C14.2471 4.074 14.9071 5.19399 14.9071 6.11399Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddOrder);
export default __webpack_public_path__ + "static/media/AddOrder.9560aa124046390072ddd7c4910db6ac.svg";
export { ForwardRef as ReactComponent };